import { render, staticRenderFns } from "./CKEditor.vue?vue&type=template&id=76f71292"
import script from "./CKEditor.vue?vue&type=script&lang=js"
export * from "./CKEditor.vue?vue&type=script&lang=js"
import style0 from "./CKEditor.vue?vue&type=style&index=0&id=76f71292&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports